<!--====================================
=            ECOMMERCE CART            =
=====================================-->
<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Ecommerce Cart</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="8">
        <base-card class="pa-2">
          <div slot="card-header">Cart</div>
          <div slot="card-body">
            <div class="table-responsive">
              <table class="table table-centered mb-0 table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th>Product</th>
                    <th>Product Desc</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th colspan="2">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <img
                        src="../../assets/img/product/img-1.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                      />
                    </td>
                    <td>
                      <h5 class="font-size-14 text-truncate">
                        <a class="text-dark">Half sleeve T-shirt</a>
                      </h5>
                      <p class="mb-0">
                        Color :
                        <span class="font-weight-medium">Maroon</span>
                      </p>
                    </td>
                    <td>$ 450</td>
                    <td>
                      <div style="width: 120px;">
                        <input type="text" value="02" name="demo_vertical" />
                      </div>
                    </td>
                    <td>$ 900</td>
                    <td>
                      <a class="action-icon text-danger">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="../../assets/img/product/img-2.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                      />
                    </td>
                    <td>
                      <h5 class="font-size-14 text-truncate">
                        <a class="text-dark">Light blue T-shirt</a>
                      </h5>
                      <p class="mb-0">
                        Color :
                        <span class="font-weight-medium">Light blue</span>
                      </p>
                    </td>
                    <td>$ 225</td>
                    <td>
                      <div style="width: 120px;">
                        <input type="text" value="01" name="demo_vertical" />
                      </div>
                    </td>
                    <td>$ 225</td>
                    <td>
                      <a class="action-icon text-danger">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="../../assets/img/product/img-3.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                      />
                    </td>
                    <td>
                      <h5 class="font-size-14 text-truncate">
                        <a class="text-dark">Black Color T-shirt</a>
                      </h5>
                      <p class="mb-0">
                        Color :
                        <span class="font-weight-medium">Black</span>
                      </p>
                    </td>
                    <td>$ 152</td>
                    <td>
                      <div style="width: 120px;">
                        <input type="text" value="02" name="demo_vertical" />
                      </div>
                    </td>
                    <td>$ 304</td>
                    <td>
                      <a class="action-icon text-danger">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="../../assets/img/product/img-4.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                      />
                    </td>
                    <td>
                      <h5 class="font-size-14 text-truncate">
                        <a class="text-dark">Hoodie (Blue)</a>
                      </h5>
                      <p class="mb-0">
                        Color :
                        <span class="font-weight-medium">Blue</span>
                      </p>
                    </td>
                    <td>$ 145</td>
                    <td>
                      <div style="width: 120px;">
                        <input type="text" value="02" name="demo_vertical" />
                      </div>
                    </td>
                    <td>$ 290</td>
                    <td>
                      <a class="action-icon text-danger">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="../../assets/img/product/img-5.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                      />
                    </td>
                    <td>
                      <h5 class="font-size-14 text-truncate">
                        <a class="text-dark">Half sleeve T-Shirt</a>
                      </h5>
                      <p class="mb-0">
                        Color :
                        <span class="font-weight-medium">Light orange</span>
                      </p>
                    </td>
                    <td>$ 138</td>
                    <td>
                      <div style="width: 120px;">
                        <input type="text" value="01" name="demo_vertical" />
                      </div>
                    </td>
                    <td>$ 138</td>
                    <td>
                      <a class="action-icon text-danger">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img
                        src="../../assets/img/product/img-6.png"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                      />
                    </td>
                    <td>
                      <h5 class="font-size-14 text-truncate">
                        <a class="text-dark">Green color T-shirt</a>
                      </h5>
                      <p class="mb-0">
                        Color :
                        <span class="font-weight-medium">Green</span>
                      </p>
                    </td>
                    <td>$ 152</td>
                    <td>
                      <div style="width: 120px;">
                        <input type="text" value="02" name="demo_vertical" />
                      </div>
                    </td>
                    <td>$ 304</td>
                    <td>
                      <a class="action-icon text-danger">
                        <i class="mdi mdi-trash-can font-size-18"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <a class="btn white--text btn-secondary">
                  <i class="mdi mdi-arrow-left mr-1"></i> Continue Shopping
                </a>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-sm-right mt-2 mt-sm-0">
                  <a class="btn white--text btn-success">
                    <i class="mdi mdi-cart-arrow-right mr-1"></i> Checkout
                  </a>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <base-card class="pa-2">
          <div slot="card-header">Order Summary</div>
          <div slot="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <td>Grand Total :</td>
                    <td>$ 1,857</td>
                  </tr>
                  <tr>
                    <td>Discount :</td>
                    <td>- $ 157</td>
                  </tr>
                  <tr>
                    <td>Shipping Charge :</td>
                    <td>$ 25</td>
                  </tr>
                  <tr>
                    <td>Estimated Tax :</td>
                    <td>$ 19.22</td>
                  </tr>
                  <tr>
                    <th>Total :</th>
                    <th>$ 1744.22</th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";

export default {
  components: {
    BaseCard,
    BaseHeader
  },
  mounted() {
    $(".select2").select2();
  }
};
</script>
<!--====  End of ECOMMERCE CART  ====-->